import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from "@angular/router";
import { Injectable, inject } from "@angular/core";
import { logInfo, sntLog } from "../common/logger";
import { sntNavigate } from "src/app/support/router";
import { AuthService } from "src/app/services/auth.service";
import { AUTH_FEATURES } from "src/app/tokens/auth-features.token";

const logger = sntLog("AuthGuard");

@Injectable()
export class AuthGuard {
  readonly #router = inject(Router);
  readonly #authService = inject(AuthService);
  readonly #authFeatures = inject(AUTH_FEATURES);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    logger.info("canActivate");

    const isAuthenticated = await this.#authService.isAuthenticated();

    if (!isAuthenticated) {
      logInfo("User not authenticaed, redirecting to /auth");

      const returnUrl = `${location.pathname}${location.search}`;

      sntNavigate(this.#router, ["auth"], {
        queryParams: {
          returnUrl,
          ...this.#authFeatures
        }
      });

      return false;
    }

    return true;
  }
}
